import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { InventionDetails, InventionResponse, InventionContact, InventionContactResponse } from '../models/invention.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class InventionService {
    private baseUrl: string;
    private api: string = "api/Invention";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Invention Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

    async getInventionAsync(encryptedUser: string, inventionId: number): Promise<InventionResponse | void> {
        const a = await this.httpClient
            .get<InventionResponse>(`${this.baseUrl}/GetInvention/${inventionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser,
                    'Retry-After': '15'
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, encryptedUser, "InventionService", "getInventionAsync"); });

        return a;
    }

    async getInventionByContactIdAsync(encryptedUser: string, contactId: number, clpUserId: number, contractType: string): Promise<InventionContactResponse | void> {
        const a = await this.httpClient
            .get<InventionContactResponse>(`${this.baseUrl}/GetInventionByContactId/${contactId}/${clpUserId}/${contractType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contactId - " + contactId + " ClpUserId - " + clpUserId, encryptedUser, "InventionService", "getInventionByContactIdAsync"); });

        return a;
    }

    async updateInventionAsync(encryptedUser: string, inventionDetails: InventionDetails): Promise<InventionResponse | void> {
        const a = await this.httpClient.post<InventionResponse>(`${this.baseUrl}/UpdateInventionName/${inventionDetails.InventionId}`, inventionDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, inventionDetails, "", encryptedUser, "InventionService", "updateInventionAsync"); });

        return a;
    }

    async updateInventionDetailsAsync(encryptedUser: string, inventionDetails: InventionDetails): Promise<InventionResponse | void> {
        const a = await this.httpClient.post<InventionResponse>(this.baseUrl, inventionDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, inventionDetails, "", encryptedUser, "InventionService", "updateInventionDetailsAsync"); });


        return a;
    }

    async createInventionAsync(encryptedUser: string, officeNum: number, clpUserId: number, inventionDetails: InventionDetails): Promise<InventionResponse | void> {
        const a = await this.httpClient.post<InventionResponse>(`${this.baseUrl}/CreateInvention/${officeNum}/${clpUserId}`, inventionDetails, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionName - " + inventionDetails.InventionName + " contactId - " + inventionDetails.I1CLPContactId + " officeNum - " + officeNum + " clpUserId - " + clpUserId, encryptedUser, "InventionService", "createInventionAsync"); });
        return a;
    }

    async getBIPExistforInventionAsync(encryptedUser: string, inventionId: number): Promise<boolean | void> {
        const a = await this.httpClient
            .get<boolean>(`${this.baseUrl}/GetBIPExistforInvention/${inventionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, encryptedUser, "InventionService", "getBIPExistforInventionAsync"); });
        return a;
    }
}
